module.exports = __webpack_public_path__ + "static/6-56ab9f913cdc1c97ef81eb275ebaf464.jpeg";